//GeneratorFlag:[NoChange]
import Tenant from './tenant';
import City from './city';
import TenantType from './tenant-type';

export default {Tenant, City, TenantType}
export{Tenant, City, TenantType}